import styled from 'styled-components';
import { halfStep, zIndex, shadows } from 'tokens';

export const ColorSection = styled.span`
	display: inline-block;
	cursor: pointer;
`;

type SwatchProps = {
	size?: string;
	color: string;
};
export const Swatch = styled.div.attrs((props) => ({
	style: {
		backgroundColor: props.color,
	},
}))<SwatchProps>`
	box-sizing: border-box;
	width: 14px;
	height: 14px;
	border-radius: 2px;
	border: 0px solid #fff;
	margin-left: -2px;
`;

export const ColorInput = styled.div`
	position: absolute; // Relative not to the swatch but the friendly mode container.
	left: 12px;
	z-index: ${zIndex.panelOverlay};

	border: 1px solid ${({ theme }) => theme.gray[100]};
	border-radius: 2px;

	box-shadow: ${shadows.md};
	display: flex;
	flex-direction: column;
	gap: ${halfStep}px;
	background-color: ${({ theme }) => theme.gray[0]};

	padding: ${halfStep}px;

	.react-colorful__saturation {
		border-radius: 2px;
	}

	.react-colorful__hue {
		height: 14px;
		border-radius: 2px;
		margin-top: ${halfStep}px;
	}

	.react-colorful__pointer {
		width: 20px;
		height: 20px;
	}
`;
